/**
 * Created by yqdong on 2018/3/18.
 * qq: 1013501639
 * @author yqdong
 *
 */
import { mutations, actions, apis, getters } from '../constants'
import Store from '../Store'
import util from '../../utils/util'

export default function (ajax) {
  let store = new Store({
    state: {
      
    },
    mutations: {
    },
    actions: {
      [actions.analysis.queryData] (context, data) {
        return new Promise((resolve, reject) => {
          const unique = data.unique
          delete data.unique
          ajax({
            url: apis.analysis.queryData,
            method: 'post',
            data,
            unique,
            useTransform: true
          })
          .then(res => {
            resolve(res.app_data)
          })
          .catch(reject)
        })
      },
      [actions.analysis.appUpdateTime](context, platId) {
        return new Promise((resolve, reject) => {
          ajax({
            url: apis.analysis.appUpdateTime,
            method: "post",
            data: {
              appId: util.getParamByUrl('appId') || context.rootState.bizSys.currentApp.id,
              plat: platId || 0
            },
            useTransform: true
          })
            .then(res => {
              resolve(res);
            })
            .catch(err => {
              reject(err);
            });
        })
      }
    }
  })
  return store
}
